import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {SubService} from './sub-service.model';
import * as SubServiceActions from './sub-service.actions';

export const subServicesFeatureKey = 'subServices';

export interface State extends EntityState<SubService> {
  // additional entities state properties
}

export const adapter: EntityAdapter<SubService> = createEntityAdapter<SubService>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(SubServiceActions.addSubService,
    (state, action) => adapter.addOne(action.subService, state)
  ),
  on(SubServiceActions.upsertSubService,
    (state, action) => adapter.upsertOne(action.subService, state)
  ),
  on(SubServiceActions.addSubServices,
    (state, action) => adapter.addMany(action.subServices, state)
  ),
  on(SubServiceActions.upsertSubServices,
    (state, action) => adapter.upsertMany(action.subServices, state)
  ),
  on(SubServiceActions.updateSubService,
    (state, action) => adapter.updateOne(action.subService, state)
  ),
  on(SubServiceActions.updateSubServices,
    (state, action) => adapter.updateMany(action.subServices, state)
  ),
  on(SubServiceActions.deleteSubService,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(SubServiceActions.deleteSubServices,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(SubServiceActions.loadSubServices,
    (state, action) => adapter.setAll(action.subServices, state)
  ),
  on(SubServiceActions.clearSubServices,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
